import { DropdownMenu as _DropdownMenu, DropdownMenuProps as _DropdownMenuProps } from "reactstrap";

    export const DropdownMenu = _DropdownMenu;
    export type DropdownMenuProps = _DropdownMenuProps;
    